import { Breadcrumbs as UIBreadcrumbs, makeStyles } from '@gogame/components';

import Breadcrumb from './Breadcrumb';
import Home from './Home';

const useStyles = makeStyles(
  {
    root: {},
    ol: {
      flexWrap: 'nowrap',
      paddingTop: 2,
      paddingBottom: 2,
    },
  },
  { name: 'GgBreadcrumbs' }
);

export const Breadcrumbs = ({
  value = [],
  onChange,
  drillEntityNameFormatter = (drillEntityName) => drillEntityName || 'All',
}) => {
  const classes = useStyles();
  return (
    <UIBreadcrumbs style={{ flexWrap: 'nowrap' }} classes={classes}>
      {value.length ? <Home onChange={onChange} {...value[0]} /> : null}
      {value.map((drillItem, i) => {
        const nextDrillItem = value[i + 1] || {};
        const { drillEntity: nextDrillEntity = {} } = nextDrillItem;
        const { drillEntity, dimension } = drillItem;

        const path = [...value.slice(0, i), drillItem].map(
          ({ dimension, drillEntity }) => ({
            type: dimension.id,
            id: drillEntity.id,
          })
        );

        if (nextDrillItem.dimension) {
          path.push({ type: nextDrillItem.dimension.id, id: '' });
        }

        return (
          <Breadcrumb
            path={path}
            onChange={nextDrillEntity.id ? onChange : undefined}
            dimensionName={dimension.name}
            dimensionId={dimension.id}
            drillEntityName={drillEntityNameFormatter({
              drillEntityName: drillEntity.name,
              dimensionId: dimension.id,
            })}
            drillEntityId={drillEntity.id}
          />
        );
      })}
    </UIBreadcrumbs>
  );
};
